<template lang="html">
  <div id="tours-products-page">

    <section class="main-section">
      <div class="container oversized-container">
        <div class="row">
          <div class="col-12 col-results">
            <div class="row">
              <div class="col-12 col-md-6 col-lg-6 col-xl-3 col-tour-s1" v-for="(tour, tInx) in tours" :key="'tInx-'+tInx">
                <router-link class="box-link" :to="'/tour/'+$root._converToURL(tour.name, tour.id)">
                  <div class="box-image">
                    <img class="placed-backg" src="public/images/pages/tours/tour.png" v-bind:style="{ backgroundImage: 'url('+tour.image+')' }">
                  </div>

                  <div class="box-info">
                    <!-- <h6 class="days"><i class="fa-light fa-calendar icon"></i> 8 Days</h6> -->
                    <h6 class="available-days">
                      <i class="fa-light fa-calendar icon"></i> 
                      <span class="pr-1">Availability: </span>
                      <small v-if="tour.monday == 1">Mo,</small>
                      <small v-if="tour.tuesday == 1">Tu,</small>
                      <small v-if="tour.wednesday == 1">We,</small>
                      <small v-if="tour.thursday == 1">Th,</small>
                      <small v-if="tour.friday == 1">Fr,</small>
                      <small v-if="tour.saturday == 1">Sa,</small>
                      <small v-if="tour.sunday == 1">Su</small>
                    </h6>

                    <h4 class="name">{{ tour.name }}</h4>

                    <!-- <div class="b-stars">
                      <b-form-rating inline value="4" readonly></b-form-rating>
                    </div> -->

                    <div class="b-price">
                      <h5 class="price">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(tour.one_guest) }}</h5>
                      <!-- <h5 class="price old-price">{{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(tour.oldPrice) }} $</h5> -->
                    </div>

                    <div class="b-description">
                      <p>
                        {{ tour.short_description }}
                      </p>
                    </div>

                    <a class="btn-explore">Explore Now</a>
                  </div>
                </router-link>
              </div>
            </div>
          </div>

          <!-- <div class="col-lg-3 col-filters">
            <div class="box-filters">
              <div class="box-top">
                <h5 class="title">Filter tours</h5>
                <a class="t-150 link-clear">Clear all</a>
              </div>

              <div class="box-form">
                <b-form @submit="onSubmit">
                  <b-form-group class="custom-f-group-s1 keywords-group">
                    <b-form-input
                      v-model="formFilter.keywords"
                      type="text"
                      placeholder="Search tour name"
                      required
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group class="custom-f-group-s1">
                    <b-form-select v-model="formFilter.location">
                      <b-form-select-option :value="null">Locations</b-form-select-option>
                      <b-form-select-option value="a">Location A</b-form-select-option>
                      <b-form-select-option value="b">Location B</b-form-select-option>
                    </b-form-select>
                  </b-form-group>

                  <b-form-group class="custom-f-group-s1 date-group">
                    <b-form-datepicker v-model="formFilter.date" placeholder="Select date" :min="minDate"></b-form-datepicker>
                  </b-form-group>

                  <b-button type="submit" class="mt-4 btn-send">Apply</b-button>
                </b-form>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  data() {
    return {
      tours: [
        // { image: 'public/images/pages/tours/tour-1.jpg', name: 'Cancun', price: 1000, oldPrice: 1200 },
        // { image: 'public/images/pages/tours/tour-2.jpg', name: 'Chichen Itza', price: 1223, oldPrice: 1400 },
        // { image: 'public/images/pages/tours/tour-3.jpg', name: 'Tulum', price: 1200, oldPrice: 1300 },
        // { image: 'public/images/pages/tours/tour-4.jpg', name: 'Playa de Carmen', price: 1100, oldPrice: 1200 },
        // { image: 'public/images/pages/tours/tour-1.jpg', name: 'Cancun', price: 1000, oldPrice: 1200 },
        // { image: 'public/images/pages/tours/tour-2.jpg', name: 'Chichen Itza', price: 1223, oldPrice: 1400 },
        // { image: 'public/images/pages/tours/tour-3.jpg', name: 'Tulum', price: 1200, oldPrice: 1300 },
        // { image: 'public/images/pages/tours/tour-4.jpg', name: 'Playa de Carmen', price: 1100, oldPrice: 1200 },
        // { image: 'public/images/pages/tours/tour-1.jpg', name: 'Cancun', price: 1000, oldPrice: 1200 },
      ],

      formFilter: {
        keywords: null,
        location: null,
        date: null,
      },

      minDate: null,
    }
  },

  methods: {
    getTours() {
      this.$root.isLoading = true;
      axios.get(tools.url('/api/tours')).then((response)=>{
        this.tours = response.data;
        this.$root.isLoading = false;
      });
    },

    onSubmit(event) {
      event.preventDefault();
    },
  },

  beforeMount(){
    const now = new Date();
    this.minDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());

    this.getTours();
  }
}
</script>
